import React from 'react'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Button, Divider, ListItemIcon, ListItemText, Menu, MenuItem, MenuList } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import HeaderDispatch from './model';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import HeaderState from '../../State/HeaderState';

class Header extends React.Component<{}>{
    private menu: EventTarget & HTMLButtonElement | undefined


    render() {
        let dispatcher: HeaderDispatch = (this.props as any).dispatcher
        let state: HeaderState = (this.props as any).state

        return (
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="fixed">
                    <Toolbar>
                        {/* <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 0.2 }}
                        >
                            <MenuIcon /> 
                        </IconButton>*/}
                        <Typography variant="subtitle1" component="div" sx={{ mr: 0.2, fontFamily: 'font-farsi-logo' }}>
                            ویـــلاگــــرام
                        </Typography>
                        <Typography variant="subtitle2" component="div" sx={{ flexGrow: 1, mr: 0.2 }}>
                            : آگهی فیک نداریم
                        </Typography>

                        <Button startIcon={<SearchIcon sx={{ ml: 1 }} />} color="inherit" onClick={() => {
                            dispatcher.filter()
                        }}>
                            جستجو
                        </Button>

                        <Box>
                            <IconButton size='small' onClick={(e) => {
                                this.menu = e.currentTarget
                                dispatcher.onMenuClicked()
                            }} color='inherit'>
                                <MoreVertIcon />
                            </IconButton >

                            <Menu
                                id="basic-menu"
                                anchorEl={this.menu}
                                open={state.menu ? true : false}
                                onClose={() => {
                                    this.menu = undefined
                                    dispatcher.onMenuClicked()
                                }}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}>
                                <Box sx={{ width: 255, maxWidth: '100%', height: '100%' }} dir='rtl'>
                                    <MenuList>


                                        <MenuItem onClick={() => {
                                            dispatcher.bookmark()
                                            dispatcher.onMenuClicked()
                                        }}>
                                            {/* <ListItemIcon>
                                                <HelpIcon fontSize="small" sx={{ ml: 1, mr: 1 }} />
                                            </ListItemIcon> */}
                                            <ListItemText>ذخیره شده ها</ListItemText>
                                        </MenuItem>

                    

                                        <MenuItem onClick={() => {
                                            dispatcher.seen()
                                            dispatcher.onMenuClicked()
                                        }}>
                                            {/* <ListItemIcon>
                                                <HistoryIcon fontSize="small" sx={{ ml: 1, mr: 1 }} />
                                            </ListItemIcon> */}
                                            <ListItemText>آخرین بازدید ها</ListItemText>
                                        </MenuItem>

                                        <MenuItem onClick={() => {
                                            dispatcher.moshaveran()
                                            dispatcher.onMenuClicked()
                                        }}>
                                            {/* <ListItemIcon>
                                                <PaidIcon fontSize="small" sx={{ ml: 1, mr: 1 }} />
                                            </ListItemIcon> */}
                                            <ListItemText>مشاوران</ListItemText>
                                        </MenuItem>

                                        <MenuItem onClick={() => {
                                            dispatcher.onMenuClicked()
                                        }}>
                                            {/* <ListItemIcon>
                                                <PasswordIcon fontSize="small" sx={{ ml: 1, mr: 1 }} />
                                            </ListItemIcon>
                                             */}
                                             <ListItemText>ویلا برای فروش دارید ؟</ListItemText>
                                        </MenuItem>

                                        <Divider />

                                        <MenuItem onClick={() => {
                                            // dispatcher.onExitClicked()
                                            dispatcher.onMenuClicked()
                                        }}>
                                            {/* <ListItemIcon>
                                                <LogoutIcon fontSize="small" sx={{ ml: 1, mr: 1, color: 'red' }} />
                                            </ListItemIcon>  */}
                                            
                                            <ListItemText>درباره ما</ListItemText>
                                        </MenuItem>
                                    </MenuList>
                                </Box>


                            </Menu>
                        </Box>
                    </Toolbar>
                </AppBar>
            </Box>
        )
    }
}

export default Header